import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import SchedulingHeader from "./SchedulingHeader";
import SchedulingTable from "./SchedulingTable";
import { loadPage } from "../../employeeScheduling/schedulingSlice";
import { convertSchedulingEventsToCalender } from "../../../components/util/helpers";

const Scheduling = (props) => {
  const { visible } = props;
  const [currentDate, setCurrentDate] = useState(moment());
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [ordersIds, setOrdersIds] = useState([]);
  const [patientsPallette, setPatientsPallette] = useState([]);
  const [events, setEvents] = useState([]);
  const { page: schedulingPage } = useSelector(
    (state) => state.employeeScheduling
  );
  const { items, order_time_extractions } = schedulingPage;

  const currentMonth = currentDate && currentDate.month();
  const currentYear = currentDate && currentDate.year();
  const loadLoading = useSelector(
    (state) => state.pendingActions["employeeScheduling/load"]
  );
  const activeEmployee = useSelector(
    (state) => state.employeeDetails.activeEmployee
  );
  const dispatch = useDispatch();
  useEffect(() => {
    let startMonth = moment([currentYear, currentMonth, 1]).startOf("month");
    let endDate = startMonth.clone().endOf("month");
    if (activeEmployee.id && visible) {
      dispatch(
        loadPage({
          filter: {
            date: {
              $gt: startMonth,
              $lt: endDate,
            },
          },
        })
      );
    }
  }, [dispatch, currentMonth, currentYear, activeEmployee, visible]);

  const pallette = [
    {
      primary: "#53C31A",
      border: "#C8D7C2",
      bg: "#F1FBEE",
    },
    {
      primary: "#F99646",
      border: "#F6BD8D",
      bg: "#FDEEE0",
    },
    {
      primary: "#6C64FE",
      border: "#D8D6FC",
      bg: "#F2EFFF",
    },
  ];

  useEffect(() => {
    const ids = [...new Set(events.map((obj) => obj.order.id))];
    setOrdersIds(ids);
    let idsPallette = [];
    ids.forEach((item, i) => {
      idsPallette.push({
        orderId: ids[i],
        primary: pallette[i] ? pallette[i].primary : "#53C31A",
        border: pallette[i] ? pallette[i].border : "#C8D7C2",
        bg: pallette[i] ? pallette[i].bg : "#F1FBEE",
      });
    });
    setPatientsPallette(idsPallette);
    setFilteredOrders([]);
  }, [events]);

  useEffect(() => {
    const convertedToCalender = convertSchedulingEventsToCalender(items);
    setEvents(convertedToCalender);
  }, [items]);

  const onNextDate = () => {
    setCurrentDate(moment(currentDate).add(1, "months").startOf("month"));
  };
  const onPreviousDate = () => {
    setCurrentDate(moment(currentDate).subtract(1, "months").startOf("month"));
  };

  const onFilterPatientsChanged = (orderId, val) => {
    const newFiltered = val
      ? filteredOrders.filter((item) => item !== orderId)
      : [...filteredOrders, orderId];
    setFilteredOrders(newFiltered);
  };

  return (
    <div style={{ maxWidth: "1000px" }}>
      <SchedulingHeader
        currentDate={currentDate}
        onFilterPatientsChanged={onFilterPatientsChanged}
        onNextDate={onNextDate}
        onPreviousDate={onPreviousDate}
        events={events}
        patientsPallette={patientsPallette}
        filteredOrders={filteredOrders}
        ordersIds={ordersIds}
        order_time_extractions={order_time_extractions}
      />
      <SchedulingTable
        filteredOrders={filteredOrders}
        events={events}
        loadLoading={loadLoading}
        patientsPallette={patientsPallette}
      />
    </div>
  );
};

export default Scheduling;
